var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "newQianniu" } },
    [
      _c(
        "el-tabs",
        {
          attrs: { "tab-position": "left" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.tabCurrent,
            callback: function($$v) {
              _vm.tabCurrent = $$v
            },
            expression: "tabCurrent"
          }
        },
        [
          _c("el-tab-pane", { attrs: { name: "zero" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("通关必看")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "startvideo", attrs: { id: "startvideo" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startVideo }
                      },
                      [_vm._v("开始学习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-zero" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "zero",
                      src:
                        "http://res.study.itaojin.cn/2023-02/2589f33edc9a487fb974cd4968040bb8.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-zero" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-first")
                          }
                        }
                      },
                      [_vm._v("继续下一步学习")]
                    )
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "first" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("1、Excel界面介绍")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-first" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "first",
                      src:
                        "http://res.study.itaojin.cn/2023-02/5f691afc34024d2da811ff4f6c245131.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon,
                          expression: "isShowQnIcon"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwps1.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon01",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwps1tb.png")
                        },
                        on: { dblclick: _vm.showLoginImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon2,
                          expression: "isShowQnIcon2"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwps2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon02-1",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwps2-1.png")
                        },
                        on: { mousemove: _vm.showLoginImg2 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon3,
                          expression: "isShowQnIcon3"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwpx2-2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon02-1",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwps2-1.png")
                        },
                        on: { click: _vm.showLoginImg3 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon4,
                          expression: "isShowQnIcon4"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwps2-3.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon04-1",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwpstb2.png")
                        },
                        on: { mousemove: _vm.showLoginImg4 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon5,
                          expression: "isShowQnIcon5"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwps2-4.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon05-1",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwpstb3.png")
                        },
                        on: { click: _vm.showLoginImg5 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon6,
                          expression: "isShowQnIcon6"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwps2-5.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon06-1",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwpstb4.png")
                        },
                        on: { mousemove: _vm.showLoginImg6 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon7,
                          expression: "isShowQnIcon7"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwps2-6.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon06-1",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwpstb4.png")
                        },
                        on: { click: _vm.showLoginImg7 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon8,
                          expression: "isShowQnIcon8"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwps2-7.png")
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon9,
                          expression: "isShowQnIcon9"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwps2-7.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon09-1",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwpstb5.png")
                        },
                        on: { click: _vm.showLoginImg8 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon10,
                          expression: "isShowQnIcon10"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwps2-8.png")
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon11,
                          expression: "isShowQnIcon11"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwps2-8.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon11-1",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwpstb6.png")
                        },
                        on: { click: _vm.showLoginImg9 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon12,
                          expression: "isShowQnIcon12"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwps2-9.png")
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon13,
                          expression: "isShowQnIcon13"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwps2-9.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "qnicon02 qnicon13-1",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwpstb7.png")
                        },
                        on: { click: _vm.showLoginImg10 }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowQnIcon14,
                          expression: "isShowQnIcon14"
                        }
                      ],
                      staticClass: "qnbox"
                    },
                    [
                      _c("img", {
                        staticClass: "qnbg",
                        attrs: {
                          src: require("../../../static/workoff/excelimg/dkwps2-10.png")
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.isShowQnIcon ? _c("p", [_vm._v("请打开WPS")]) : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowQnIcon2 ||
                  _vm.isShowQnIcon3 ||
                  _vm.isShowQnIcon4 ||
                  _vm.isShowQnIcon5 ||
                  _vm.isShowQnIcon6 ||
                  _vm.isShowQnIcon7 ||
                  _vm.isShowQnIcon8
                    ? _c("p", [_vm._v("新建一个表格")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowQnIcon9 || _vm.isShowQnIcon10
                    ? _c("p", [
                        _vm._v("选中"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("B列")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowQnIcon11 || _vm.isShowQnIcon12
                    ? _c("p", [
                        _vm._v("选择"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("第6行")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowQnIcon13 || _vm.isShowQnIcon14
                    ? _c("p", [
                        _vm._v("选择"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("B3单元格")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowLoginIndex
                    ? _c("p", [_vm._v("请进入千牛接待中心")])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFirst }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("../../../static/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("办公软件的功能学习.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "second" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("2、Excel内容编辑")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-second" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "second",
                      src:
                        "http://res.study.itaojin.cn/2023-02/bd934f84a7f94ff08ccb293a3bd739c7.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "exclenrbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_1,
                            expression: "isShownr1_1"
                          }
                        ],
                        staticClass: "qnbox"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nr1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "nr1-1tb",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nrtb1-1.png")
                          },
                          on: { click: _vm.showLoginnr1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_2,
                            expression: "isShownr1_2"
                          }
                        ],
                        staticClass: "qnbox"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nr1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.nr_input,
                              expression: "nr_input"
                            }
                          ],
                          ref: "strname",
                          staticClass: "nr1_2input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.nr_input },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.listenOne.apply(null, arguments)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.nr_input = $event.target.value
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_3,
                            expression: "isShownr1_3"
                          }
                        ],
                        staticClass: "qnbox"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nr1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "nr1-3tb",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nrtb1-1.png")
                          },
                          on: { click: _vm.showLoginnr1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_4,
                            expression: "isShownr1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nr1-4.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.nr_input2,
                              expression: "nr_input2"
                            }
                          ],
                          ref: "strname2",
                          staticClass: "nr1_4input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.nr_input2 },
                          on: {
                            keyup: function($event) {
                              if (!$event.ctrlKey) {
                                return null
                              }
                              return _vm.listenTwo.apply(null, arguments)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.nr_input2 = $event.target.value
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_5,
                            expression: "isShownr1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nr1-4.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.nr_input2,
                              expression: "nr_input2"
                            }
                          ],
                          staticClass: "nr1_4input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.nr_input2 },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.listenTwo_1.apply(null, arguments)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.nr_input2 = $event.target.value
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_6,
                            expression: "isShownr1_6"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nr1-5.png")
                          }
                        }),
                        _vm._v(" "),
                        _vm.isShownr1_6_1
                          ? _c("img", {
                              staticClass: "nr1-6tb",
                              attrs: {
                                src: require("../../../static/workoff/excelimg/nrtb1-6.png")
                              },
                              on: { click: _vm.showLoginnr1_6 }
                            })
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_7,
                            expression: "isShownr1_7"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nr1-6.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_8,
                            expression: "isShownr1_8"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nr1-7.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_9,
                            expression: "isShownr1_9"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nr1-8.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_10,
                            expression: "isShownr1_10"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nr1-9.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_11,
                            expression: "isShownr1_11"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nr1-10.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "nr1-11tb",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nrtb1-11.png")
                          },
                          on: { click: _vm.showLoginnr1_11 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_12,
                            expression: "isShownr1_12"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nr1-11.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "nr1-12tb",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nrtb1-12.png")
                          },
                          on: {
                            contextmenu: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.rightClick($event)
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_13,
                            expression: "isShownr1_13"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nr1-12.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "nr1-13tb",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nrtb1-13.png")
                          },
                          on: { mousemove: _vm.showLoginnr1_13 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_14,
                            expression: "isShownr1_14"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nr1-13.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "nr1-14tb",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nrtb1-14.png")
                          },
                          on: { click: _vm.showLoginnr1_14 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_15,
                            expression: "isShownr1_15"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nr1-14.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_16,
                            expression: "isShownr1_16"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nr1-15.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "nr1-15tb",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nrtb1-15.png")
                          },
                          on: { click: _vm.showLoginnr1_15 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_17,
                            expression: "isShownr1_17"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nr1-16.png")
                          },
                          on: {
                            contextmenu: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.showLoginnr1_16($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.isShownr1_17_1
                          ? _c("img", {
                              staticClass: "nr1-16tb",
                              attrs: {
                                src: require("../../../static/workoff/excelimg/nr1-17.png")
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShownr1_17_1
                          ? _c("img", {
                              staticClass: "nr1-17tb",
                              attrs: {
                                src: require("../../../static/workoff/excelimg/nrtb1-16.png")
                              },
                              on: { mousemove: _vm.showLoginnr1_17 }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShownr1_17_2
                          ? _c("img", {
                              staticClass: "nr1-16tb",
                              attrs: {
                                src: require("../../../static/workoff/excelimg/nr1-18.png")
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShownr1_17_2
                          ? _c("img", {
                              staticClass: "nr1-17tb",
                              attrs: {
                                src: require("../../../static/workoff/excelimg/nrtb1-17.png")
                              },
                              on: { click: _vm.showLoginnr1_17_1 }
                            })
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_18,
                            expression: "isShownr1_18"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nr1-19.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShownr1_19,
                            expression: "isShownr1_19"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/qh1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "nr1-19tb",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nrtb1-1.png")
                          },
                          on: { click: _vm.showLoginnr1_19 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowqh1_1,
                            expression: "isShowqh1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/qh1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.qh1_input,
                              expression: "qh1_input"
                            }
                          ],
                          ref: "strname_1qh",
                          staticClass: "qh1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.qh1_input },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.qh1_input = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "qh1-1tb",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/qhtb1-1.png")
                          },
                          on: { click: _vm.showLoginnr1_20 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowqh1_2,
                            expression: "isShowqh1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/qh1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.qh1_input1,
                              expression: "qh1_input1"
                            }
                          ],
                          ref: "strname_2qh",
                          staticClass: "qh1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.qh1_input1 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.qh1_input1 = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "qh1-2tb",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/qhtb1-2.png")
                          },
                          on: { click: _vm.showLoginqh1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowqh1_3,
                            expression: "isShowqh1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/qh1-4.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.qh1_input,
                              expression: "qh1_input"
                            }
                          ],
                          ref: "strname_1qh",
                          staticClass: "qh1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.qh1_input },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.qh1_input = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "qh1-3tb",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/qhtb1-3.png")
                          },
                          on: { click: _vm.showLoginqh1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowqh1_4,
                            expression: "isShowqh1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/qh1-5.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowqh1_5,
                            expression: "isShowqh1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/qh1-6.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowpj1_1,
                            expression: "isShowpj1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/pj1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "pjtb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/nrtb1-1.png")
                          },
                          on: { click: _vm.Loginpj1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowpj1_2,
                            expression: "isShowpj1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/pj1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.pj1_input,
                              expression: "pj1_input"
                            }
                          ],
                          ref: "strname_pj1",
                          staticClass: "pj1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.pj1_input },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.pj1_input = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "pjtb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/pjtb1-1.png")
                          },
                          on: { click: _vm.Loginpj1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowpj1_3,
                            expression: "isShowpj1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/pj1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.pj1_input,
                              expression: "pj1_input"
                            }
                          ],
                          ref: "strname_pj1",
                          staticClass: "pj1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.pj1_input },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.pj1_input = $event.target.value
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowpj1_4,
                            expression: "isShowpj1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/pj1-4.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzf1_1,
                            expression: "isShowzf1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/zf1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zftb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/dkwpstb7.png")
                          },
                          on: { click: _vm.Loginzf1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzf1_2,
                            expression: "isShowzf1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/zf1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.zf1_input,
                              expression: "zf1_input"
                            }
                          ],
                          ref: "strname_zf1",
                          staticClass: "zf1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.zf1_input },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.zf1_input = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "pjtb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/pjtb1-1.png")
                          },
                          on: { click: _vm.Loginzf1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzf1_3,
                            expression: "isShowzf1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/zf1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.zf1_input,
                              expression: "zf1_input"
                            }
                          ],
                          ref: "strname_zf1",
                          staticClass: "zf1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.zf1_input },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.zf1_input = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zftb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/zftb1-1.png")
                          },
                          on: { click: _vm.Loginzf1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzf1_4,
                            expression: "isShowzf1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/zf1-4.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzf1_5,
                            expression: "isShowzf1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/zf1-5.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxg1_1,
                            expression: "isShowxg1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/xg1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xgtb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/xgtb1-1.png")
                          },
                          on: { click: _vm.Loginxg1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxg1_2,
                            expression: "isShowxg1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/xg1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.xg_input1,
                              expression: "xg_input1"
                            }
                          ],
                          ref: "strname_xg1",
                          staticClass: "xg1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.xg_input1 },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showLoginxg1_1.apply(null, arguments)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.xg_input1 = $event.target.value
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxg1_3,
                            expression: "isShowxg1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/xg1-3.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxj1_1,
                            expression: "isShowxj1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/xj1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xjtb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/xjtb1-1.png")
                          },
                          on: { mousemove: _vm.Loginxj1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxj1_2,
                            expression: "isShowxj1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/xj1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xjtb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/xjtb1-2.png")
                          },
                          on: { click: _vm.Loginxj1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxj1_3,
                            expression: "isShowxj1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/xj1-3.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzb1_1,
                            expression: "isShowzb1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/zb1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "qnicon02 zbtb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/dkwpstb7.png")
                          },
                          on: { click: _vm.Loginzb1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzb1_2,
                            expression: "isShowzb1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/zb1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.zb_input1,
                              expression: "zb_input1"
                            }
                          ],
                          ref: "strname_zb1",
                          staticClass: "zb1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.zb_input1 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.zb_input1 = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zbtb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/zbtb1-1.png")
                          },
                          on: { click: _vm.Loginzb1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzb1_3,
                            expression: "isShowzb1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/zb1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.zb_input1,
                              expression: "zb_input1"
                            }
                          ],
                          ref: "strname_zb1",
                          staticClass: "zb1_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.zb_input1 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.zb_input1 = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zbtb1-3",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/zbtb1-2.png")
                          },
                          on: { click: _vm.Loginzb1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzb1_4,
                            expression: "isShowzb1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/zb1-4.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzb1_5,
                            expression: "isShowzb1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/zb1-5.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxg2_1,
                            expression: "isShowxg2_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/xg2-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xgtb2-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/xgtb2-1.png")
                          },
                          on: { click: _vm.Loginxg2_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxg2_2,
                            expression: "isShowxg2_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/xg2-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.xg_input2,
                              expression: "xg_input2"
                            }
                          ],
                          ref: "strname_xg2",
                          staticClass: "xg2_1input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.xg_input2 },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.showLoginxg2_1.apply(null, arguments)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.xg_input2 = $event.target.value
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxg2_3,
                            expression: "isShowxg2_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/xg2-3.png")
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  (_vm.isShownr1_1 && _vm.isShownr1_3_1 == false) ||
                  (_vm.isShownr1_2 && _vm.isShownr1_3_1 == false) ||
                  (_vm.isShownr1_3 && _vm.isShownr1_3_1 == false)
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("J2")]
                        ),
                        _vm._v("单元格输入"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("总分较8月上升（下降）")]
                        ),
                        _vm._v("并按"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("Enter键")]
                        ),
                        _vm._v("确定\n\t\t\t\t\t\t")
                      ])
                    : _vm._e(),
                  (_vm.isShownr1_3 && _vm.isShownr1_3_1) ||
                  _vm.isShownr1_4 ||
                  _vm.isShownr1_5 ||
                  (_vm.isShownr1_6 && _vm.isShownr1_6_1 == false)
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("A3")]
                        ),
                        _vm._v("单元格先使用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("快捷键")]
                        ),
                        _vm._v("的方式录入当前日期，再将日期修改为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("2022/9/29")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.isShownr1_6 && _vm.isShownr1_6_1) ||
                  _vm.isShownr1_7 ||
                  _vm.isShownr1_8 ||
                  _vm.isShownr1_9 ||
                  _vm.isShownr1_9
                    ? _c("p", [
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("使用复制快捷键")]
                        ),
                        _vm._v("复制"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("A3")]
                        ),
                        _vm._v("单元格日期，"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("使用粘贴快捷键")]
                        ),
                        _vm._v("粘贴日期")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShownr1_11 ||
                  _vm.isShownr1_12 ||
                  _vm.isShownr1_13 ||
                  _vm.isShownr1_14 ||
                  _vm.isShownr1_15
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("姓名列右侧")]
                        ),
                        _vm._v("插入一列")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShownr1_16 || _vm.isShownr1_17 || _vm.isShownr1_18
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("第6行上方")]
                        ),
                        _vm._v("插入一行")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShownr1_19 ||
                  _vm.isShowqh1_1 ||
                  _vm.isShowqh1_2 ||
                  _vm.isShowqh1_3 ||
                  _vm.isShowqh1_4 ||
                  _vm.isShowqh1_5
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("I3")]
                        ),
                        _vm._v("单元格中，采用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("单元格相加")]
                        ),
                        _vm._v("的方式计算9月总分")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowpj1_1 ||
                  _vm.isShowpj1_2 ||
                  _vm.isShowpj1_3 ||
                  _vm.isShowpj1_4
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("J3")]
                        ),
                        _vm._v("单元格中，采用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("单元格相除")]
                        ),
                        _vm._v("的方式计算平均分")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowzf1_1 ||
                  _vm.isShowzf1_2 ||
                  _vm.isShowzf1_3 ||
                  _vm.isShowzf1_4 ||
                  _vm.isShowzf1_5
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("K3")]
                        ),
                        _vm._v("单元格中，采用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("单元格相减")]
                        ),
                        _vm._v("的方式计算总分较8月上升（下降）")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowxg1_1 || _vm.isShowxg1_2 || _vm.isShowxg1_3
                    ? _c("p", [
                        _vm._v("将工作表"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("Sheet1")]
                        ),
                        _vm._v("名称修改为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("成绩汇总")]
                        ),
                        _vm._v("并按"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("Enter键")]
                        ),
                        _vm._v("确定")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowxj1_1 || _vm.isShowxj1_2 || _vm.isShowxj1_3
                    ? _c("p", [
                        _vm._v("新建一个"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("工作表")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowzb1_1 ||
                  _vm.isShowzb1_2 ||
                  _vm.isShowzb1_3 ||
                  _vm.isShowzb1_4 ||
                  _vm.isShowzb1_5
                    ? _c("p", [
                        _vm._v("在"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("C3")]
                        ),
                        _vm._v("单元格中计算290分及以上的人数"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("在总人数中的占比")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowxg2_1 || _vm.isShowxg2_2 || _vm.isShowxg2_3
                    ? _c("p", [
                        _vm._v("将工作表"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("Sheet2")]
                        ),
                        _vm._v("名称修改为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("数据统计")]
                        ),
                        _vm._v("并按"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("Enter键")]
                        ),
                        _vm._v("确定")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudySecond }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("../../../static/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("办公软件的功能学习.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt2
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt2(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt2 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer2" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "third" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("3、Excel内容布局")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-third" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "third",
                      src:
                        "http://res.study.itaojin.cn/2023-02/3f087b31498b48479e7249cfa12ef8dd.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "exclenrbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzt1_1,
                            expression: "isShowzt1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/zt1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zttb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/zttb1-1.png")
                          },
                          on: { mousemove: _vm.Loginzt1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzt1_2,
                            expression: "isShowzt1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/zt1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zttb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/zttb1-1.png")
                          },
                          on: { click: _vm.Loginzt1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzt1_3,
                            expression: "isShowzt1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/zt1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zttb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/zttb1-2.png")
                          },
                          on: { mousemove: _vm.Loginzt1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzt1_4,
                            expression: "isShowzt1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/zt1-4.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zttb1-3",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/zttb1-3.png")
                          },
                          on: { click: _vm.Loginzt1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzt1_5,
                            expression: "isShowzt1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/zt1-5.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjz1_1,
                            expression: "isShowjz1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/zt1-5.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jztb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jztb1-1.png")
                          },
                          on: { mousemove: _vm.Loginjz1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjz1_2,
                            expression: "isShowjz1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jz1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jztb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jztb1-2.png")
                          },
                          on: { click: _vm.Loginjz1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjz1_3,
                            expression: "isShowjz1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jz1-2.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowkx1_1,
                            expression: "isShowkx1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jz1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "kxtb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/kxtb1-1 (2).png")
                          },
                          on: { mousemove: _vm.Loginkx1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowkx1_2,
                            expression: "isShowkx1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/kx1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "kxtb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/kxtb1-2.png")
                          },
                          on: { click: _vm.Loginkx1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowkx1_3,
                            expression: "isShowkx1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/kx1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "kxtb1-3",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/kxtb1-3.png")
                          },
                          on: { mousemove: _vm.Loginkx1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowkx1_4,
                            expression: "isShowkx1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/kx1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "kxtb1-4",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/kxtb1-4.png")
                          },
                          on: { click: _vm.Loginkx1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowkx1_5,
                            expression: "isShowkx1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/kx1-4.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowta1_2,
                            expression: "isShowta1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/ta1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "tatb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/tatb1-3.png")
                          },
                          on: { dblclick: _vm.Loginta1_2 }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "dbclick",
                          attrs: {
                            src: require("./bg.png"),
                            alt: "",
                            srcset: ""
                          },
                          on: { dblclick: _vm.Loginta1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowta1_3,
                            expression: "isShowta1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/ta1-3.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_1,
                            expression: "isShowjchb1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchb1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchbtb1-1.png")
                          },
                          on: { mousemove: _vm.Loginjchb1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_2,
                            expression: "isShowjchb1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchb1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchbtb1-2.png")
                          },
                          on: { click: _vm.Loginjchb1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_3,
                            expression: "isShowjchb1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchb1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchbtb1-2.png")
                          },
                          on: { click: _vm.Loginjchb1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_4,
                            expression: "isShowjchb1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchb1-4.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-4",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchbtb1-2-1.png")
                          },
                          on: { mousemove: _vm.Loginjchb1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_5,
                            expression: "isShowjchb1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchb1-5.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-5",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchbtb1-3.png")
                          },
                          on: { click: _vm.Loginjchb1_5 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_6,
                            expression: "isShowjchb1_6"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchb1-6.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-6",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchbtb1-4.png")
                          },
                          on: { mousemove: _vm.Loginjchb1_6 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_7,
                            expression: "isShowjchb1_7"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchb1-7.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-7",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchbtb1-5.png")
                          },
                          on: { click: _vm.Loginjchb1_7 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_8,
                            expression: "isShowjchb1_8"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchb1-8.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-8",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchbtb1-6.png")
                          },
                          on: { mousemove: _vm.Loginjchb1_8 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_9,
                            expression: "isShowjchb1_9"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchb1-9.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-9",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchbtb1-7.png")
                          },
                          on: { click: _vm.Loginjchb1_9 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_10,
                            expression: "isShowjchb1_10"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchb1-10.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-10",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchbtb1-8.png")
                          },
                          on: { mousemove: _vm.Loginjchb1_10 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_11,
                            expression: "isShowjchb1_11"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchb1-11.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-11",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchbtb1-8.png")
                          },
                          on: { click: _vm.Loginjchb1_11 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowjchb1_12,
                            expression: "isShowjchb1_12"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchb1-12.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowyshh1_1,
                            expression: "isShowyshh1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/yshh1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "yshhtb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/yshhtb1-1.png")
                          },
                          on: { mousemove: _vm.Loginyshh1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowyshh1_2,
                            expression: "isShowyshh1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/yshh1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "yshhtb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/yshhtb1-2.png")
                          },
                          on: { click: _vm.Loginyshh1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowyshh1_3,
                            expression: "isShowyshh1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/yshh1-3-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "yshhtb1-3",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/yshhtb1-3.png")
                          },
                          on: { mousemove: _vm.Loginyshh1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowyshh1_4,
                            expression: "isShowyshh1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/yshh1-3-2.jpg")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "yshhtb1-4",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/yshhtb1-4.png")
                          },
                          on: { click: _vm.Loginyshh1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowyshh1_5,
                            expression: "isShowyshh1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/yshh1-7.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowdj1_1,
                            expression: "isShowdj1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/dj1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "djtb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/djtb1-1.png")
                          },
                          on: { mousemove: _vm.Logindj1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowdj1_2,
                            expression: "isShowdj1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/dj1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "djtb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/djtb1-2.png")
                          },
                          on: { click: _vm.Logindj1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowdj1_3,
                            expression: "isShowdj1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/dj1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "djtb1-3",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/djtb1-3.png")
                          },
                          on: { mousemove: _vm.Logindj1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowdj1_4,
                            expression: "isShowdj1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/dj1-4.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "djtb1-4",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/djtb1-4.png")
                          },
                          on: { click: _vm.Logindj1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowdj1_5,
                            expression: "isShowdj1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/dj1-5.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_1,
                            expression: "isShowxs1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xs1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xstb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xstb1-1.png")
                          },
                          on: { mousemove: _vm.Loginxs1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_2,
                            expression: "isShowxs1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xs1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xstb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xstb1-2.png")
                          },
                          on: { click: _vm.Loginxs1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_3,
                            expression: "isShowxs1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xs1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xstb1-3",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xstb1-3.png")
                          },
                          on: { mousemove: _vm.Loginxs1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_4,
                            expression: "isShowxs1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xs1-4.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xstb1-4",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xstb1-4.png")
                          },
                          on: { click: _vm.Loginxs1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_5,
                            expression: "isShowxs1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xs1-5.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xstb1-5",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xstb1-5.png")
                          },
                          on: { click: _vm.Loginxs1_5 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_6,
                            expression: "isShowxs1_6"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xs1-6.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xstb1-6",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xstb1-6.png")
                          },
                          on: { mousemove: _vm.Loginxs1_6 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_7,
                            expression: "isShowxs1_7"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xs1-7.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xstb1-7",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xstb1-7.png")
                          },
                          on: { click: _vm.Loginxs1_7 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_8,
                            expression: "isShowxs1_8"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xs1-8.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xstb1-8",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xstb1-8.png")
                          },
                          on: { mousemove: _vm.Loginxs1_8 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_9,
                            expression: "isShowxs1_9"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xs1-9.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "xstb1-9",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xstb1-9.png")
                          },
                          on: { click: _vm.Loginxs1_9 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowxs1_10,
                            expression: "isShowxs1_10"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xs1-10.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzbbl1_1,
                            expression: "isShowzbbl1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/zbbl1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zbbltb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xstb1-1.png")
                          },
                          on: { mousemove: _vm.Loginzbbl1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzbbl1_2,
                            expression: "isShowzbbl1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/zbbl1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zbbltb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/xstb1-2.png")
                          },
                          on: { click: _vm.Loginzbbl1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzbbl1_3,
                            expression: "isShowzbbl1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/zbbl1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zbbltb1-3",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/zbbltb1-1.png")
                          },
                          on: { mousemove: _vm.Loginzbbl1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzbbl1_4,
                            expression: "isShowzbbl1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/zbbl1-4.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zbbltb1-4",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/zbbltb1-2.png")
                          },
                          on: { click: _vm.Loginzbbl1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowzbbl1_5,
                            expression: "isShowzbbl1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/zbbl1-5.png")
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.isShowzt1_1 ||
                  _vm.isShowzt1_2 ||
                  _vm.isShowzt1_3 ||
                  _vm.isShowzt1_4 ||
                  _vm.isShowzt1_5
                    ? _c("p", [
                        _vm._v("请将字体设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("微软雅黑")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowjz1_1 || _vm.isShowjz1_2 || _vm.isShowjz1_3
                    ? _c("p", [
                        _vm._v("将内容"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("水平居中")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowkx1_1 ||
                  _vm.isShowkx1_2 ||
                  _vm.isShowkx1_3 ||
                  _vm.isShowkx1_4 ||
                  _vm.isShowkx1_5
                    ? _c("p", [
                        _vm._v("将框线设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("所有框线")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowta1_2 || _vm.isShowta1_3
                    ? _c("p", [
                        _vm._v("补充知识:"),
                        _c("br"),
                        _vm._v("请采用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("双击鼠标")]
                        ),
                        _vm._v("的方式调整"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("A列")]
                        ),
                        _vm._v("宽度")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowjchb1_1 ||
                  _vm.isShowjchb1_2 ||
                  _vm.isShowjchb1_3 ||
                  _vm.isShowjchb1_4 ||
                  _vm.isShowjchb1_5 ||
                  _vm.isShowjchb1_6 ||
                  _vm.isShowjchb1_7 ||
                  _vm.isShowjchb1_8 ||
                  _vm.isShowjchb1_9 ||
                  _vm.isShowjchb1_10 ||
                  _vm.isShowjchb1_11 ||
                  _vm.isShowjchb1_12
                    ? _c("p", [
                        _vm._v("1、将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("第1行")]
                        ),
                        _vm._v("字号大小"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("逐步加大到14号")]
                        ),
                        _c("br"),
                        _vm._v("2、"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("字体加粗")]
                        ),
                        _vm._v("；"),
                        _c("br"),
                        _vm._v("3、合并"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("A1-K1")]
                        ),
                        _vm._v("单元格；"),
                        _c("br"),
                        _vm._v("4、将背景填充为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("浅蓝色")]
                        ),
                        _vm._v("（第二行倒数第二个颜色）")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowyshh1_1 || _vm.isShowyshh1_2
                    ? _c("p", [
                        _vm._v("1、将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("I2-K2")]
                        ),
                        _vm._v("字体设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("红色")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowyshh1_3 || _vm.isShowyshh1_4 || _vm.isShowyshh1_5
                    ? _c("p", [
                        _vm._v("2、将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("K2")]
                        ),
                        _vm._v("单元格内的内容"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("自动换行")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowdj1_1 ||
                  _vm.isShowdj1_2 ||
                  _vm.isShowdj1_3 ||
                  _vm.isShowdj1_4 ||
                  _vm.isShowdj1_5
                    ? _c("p", [
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("冻结")]
                        ),
                        _vm._v("第"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("1")]
                        ),
                        _vm._v("行和第"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("2")]
                        ),
                        _vm._v("行")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowxs1_1 ||
                  _vm.isShowxs1_2 ||
                  _vm.isShowxs1_3 ||
                  _vm.isShowxs1_4 ||
                  _vm.isShowxs1_5 ||
                  _vm.isShowxs1_6 ||
                  _vm.isShowxs1_7 ||
                  _vm.isShowxs1_8 ||
                  _vm.isShowxs1_9 ||
                  _vm.isShowxs1_10
                    ? _c("p", [
                        _vm._v("将平均分设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("1位小数")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowzbbl1_1 ||
                  _vm.isShowzbbl1_2 ||
                  _vm.isShowzbbl1_3 ||
                  _vm.isShowzbbl1_4 ||
                  _vm.isShowzbbl1_5
                    ? _c("p", [
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("占比")]
                        ),
                        _vm._v("用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("百分比")]
                        ),
                        _vm._v("表示，保留2位小数")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyThird }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("../../../static/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("办公软件的功能学习.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt3
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt3(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt3 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer3" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "four" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("4、保存文件")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-four" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "four",
                      src:
                        "http://res.study.itaojin.cn/2023-02/1811f87020ab466db890f5b601f915be.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "exclenrbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowbc1_1,
                            expression: "isShowbc1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bc1-1.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowbc1_2,
                            expression: "isShowbc1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bc1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "bctb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bctb1-1.png")
                          },
                          on: { mousemove: _vm.Loginbc1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowbc1_3,
                            expression: "isShowbc1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bc1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "bctb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bctb1-2.png")
                          },
                          on: { click: _vm.Loginbc1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowbc1_4,
                            expression: "isShowbc1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bc1-4.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "bctb1-3",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bctb1-3.png")
                          },
                          on: { mousemove: _vm.Loginbc1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowbc1_5,
                            expression: "isShowbc1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bc1-5.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "bctb1-4",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bctb1-4.png")
                          },
                          on: { dblclick: _vm.Loginbc1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowbc1_6,
                            expression: "isShowbc1_6"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bc1-6.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "bctb1-5",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bctb1-5.png")
                          },
                          on: { click: _vm.Loginbc1_5 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowbc1_7,
                            expression: "isShowbc1_7"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bc1-7.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "bctb1-6",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bctb1-6.png")
                          },
                          on: { click: _vm.Loginbc1_6 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowbc1_8,
                            expression: "isShowbc1_8"
                          }
                        ],
                        staticClass: "qnbox nr1_4 inputlength"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bc1-8.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.bc_input2,
                              expression: "bc_input2"
                            }
                          ],
                          ref: "strname_bc2",
                          staticClass: "bc_2input",
                          attrs: { type: "text" },
                          domProps: { value: _vm.bc_input2 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.bc_input2 = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "bctb1-7",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bctb1-7.png")
                          },
                          on: { click: _vm.Loginbc1_7 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowbc1_9,
                            expression: "isShowbc1_9"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bc1-9.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowlc1_1,
                            expression: "isShowlc1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bc1-9.png")
                          },
                          on: {
                            contextmenu: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.Loginlc1_1($event)
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowlc1_2,
                            expression: "isShowlc1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bc1-9.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "lc1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/lc1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "lctb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/lctb1-1.png")
                          },
                          on: { mousemove: _vm.Loginlc1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowlc1_3,
                            expression: "isShowlc1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bc1-9.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "lc1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/lc1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "lctb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/lctb1-2.png")
                          },
                          on: { click: _vm.Loginlc1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowlc1_4,
                            expression: "isShowlc1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "lc1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/lc1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "lctb1-3",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/lctb1-3.png")
                          },
                          on: { mousemove: _vm.Loginlc1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowlc1_5,
                            expression: "isShowlc1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "lc1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/lc1-4.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "lctb1-4",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bctb1-2.png")
                          },
                          on: { click: _vm.Loginlc1_5 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowlc1_6,
                            expression: "isShowlc1_6"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "lc1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/lc1-5.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "lctb1-5",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bctb1-7.png")
                          },
                          on: { click: _vm.Loginlc1_6 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowlc1_7,
                            expression: "isShowlc1_7"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "lc1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bc1-9.png")
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.isShowbc1_1
                    ? _c("p", [
                        _vm._v("使用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("快捷键")]
                        ),
                        _vm._v("打开文件保存路径，将表格保存到"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("桌面")]
                        ),
                        _vm._v("的"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("办公软件培训")]
                        ),
                        _vm._v("文件夹中，并将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("文件名称")]
                        ),
                        _vm._v("修改为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("月考成绩统计")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowbc1_2 || _vm.isShowbc1_3
                    ? _c("p", [
                        _vm._v("选择"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("我的桌面")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowbc1_4 || _vm.isShowbc1_5
                    ? _c("p", [
                        _vm._v("鼠标左键"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("双击办公软件培训")]
                        ),
                        _vm._v("，打开文件夹")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowbc1_6 ||
                  _vm.isShowbc1_7 ||
                  _vm.isShowbc1_8 ||
                  _vm.isShowbc1_9
                    ? _c("p", [
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("文件名")]
                        ),
                        _vm._v("修改为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("月考成绩统计，并点击保存")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowlc1_1 ||
                  _vm.isShowlc1_2 ||
                  _vm.isShowlc1_3 ||
                  _vm.isShowlc1_4 ||
                  _vm.isShowlc1_5 ||
                  _vm.isShowlc1_6 ||
                  _vm.isShowlc1_7
                    ? _c("p", [
                        _vm._v("将文件另存到"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("桌面")]
                        )
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFour }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("../../../static/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("办公软件的功能学习.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt4
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt4(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt4 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer4" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "five" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("5、发送文件")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-five" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "five",
                      src:
                        "http://res.study.itaojin.cn/2023-02/78ceee7e08034c37a419140a8a5298a0.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "exclenrbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowfs1_1,
                            expression: "isShowfs1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/bc1-9.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "fstb1-0",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/fstb1-3.png")
                          },
                          on: { mousemove: _vm.Loginfs1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowfs1_2,
                            expression: "isShowfs1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/fs1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "fstb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/fstb1-1.png")
                          },
                          on: { click: _vm.Loginfs1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowfs1_3,
                            expression: "isShowfs1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/fs1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "fstb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/fstb1-2.png")
                          },
                          on: { click: _vm.Loginfs1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowfs1_4,
                            expression: "isShowfs1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/fs1-3.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowfs1_5,
                            expression: "isShowfs1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/fs1-4.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowfs1_6,
                            expression: "isShowfs1_6"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/fs1-5.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "fstb1-3",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/fstb1-4.png")
                          },
                          on: { click: _vm.Loginfs1_6 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowfs1_7,
                            expression: "isShowfs1_7"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/SaveFile/fs1-6.png")
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.isShowfs1_1 ||
                  _vm.isShowfs1_2 ||
                  _vm.isShowfs1_3 ||
                  _vm.isShowfs1_4 ||
                  _vm.isShowfs1_5 ||
                  _vm.isShowfs1_6 ||
                  _vm.isShowfs1_7
                    ? _c("p", [
                        _vm._v("1、关闭表格;"),
                        _c("br"),
                        _vm._v("2、使用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("复制快捷键")]
                        ),
                        _vm._v("复制表格;"),
                        _c("br"),
                        _vm._v("3、使用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("粘贴快捷键")]
                        ),
                        _vm._v("粘贴表格到QQ群，并发送")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartStudyFive }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重练")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("../../../static/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("办公软件的功能学习.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt5
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt5(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt5 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer5" } })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { name: "six" } }, [
            _c(
              "div",
              {
                staticClass: "tab-slot",
                attrs: { slot: "label" },
                slot: "label"
              },
              [
                _c("p", { staticClass: "title" }, [_vm._v("6、Word基础功能")]),
                _vm._v(" "),
                _c("div", { staticClass: "hover-con" }, [
                  _c("p", [_c("i", { staticClass: "el-icon-video-play" })]),
                  _vm._v(" "),
                  _c("p", [_vm._v("点击学习")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "video-box", attrs: { id: "video-six" } },
              [
                _c(
                  "video",
                  {
                    staticClass: "video",
                    attrs: {
                      id: "six",
                      src:
                        "http://res.study.itaojin.cn/2023-02/0671010263394b0993b576b5ff316603.mp4",
                      controls: "controls"
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t您的浏览器不支持 video 标签。\n\t\t\t\t\t"
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("视频学习完毕，根据提示实操练习")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "restart",
                        on: { click: _vm.restartVideo }
                      },
                      [
                        _c("i", { staticClass: "el-icon-refresh-left" }),
                        _vm._v("重播")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "exclenrbox" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_1,
                            expression: "isShowwdzt1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdzt1-1.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_2,
                            expression: "isShowwdzt1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdzt1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "zttb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/zttb1-1.png")
                          },
                          on: { mousemove: _vm.Loginwdzt1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_3,
                            expression: "isShowwdzt1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdzt1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdzttb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdzttb1-1.png")
                          },
                          on: { click: _vm.Loginwdzt1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_4,
                            expression: "isShowwdzt1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdzt1-4.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdzttb1-3",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdzttb1-2.png")
                          },
                          on: { mousemove: _vm.Loginwdzt1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_5,
                            expression: "isShowwdzt1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdzt1-5.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdzttb1-4",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdzttb1-3.png")
                          },
                          on: { click: _vm.Loginwdzt1_5 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_6,
                            expression: "isShowwdzt1_6"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdzt1-6.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdzttb1-5",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/zttb1-1.png")
                          },
                          on: { mousemove: _vm.Loginwdzt1_6 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_7,
                            expression: "isShowwdzt1_7"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdzt1-7.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdzttb1-6",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdzttb1-1.png")
                          },
                          on: { click: _vm.Loginwdzt1_7 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_8,
                            expression: "isShowwdzt1_8"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdzt1-8.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdzttb1-7",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdzttb1-4.png")
                          },
                          on: { mousemove: _vm.Loginwdzt1_8 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_9,
                            expression: "isShowwdzt1_9"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdzt1-9.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdzttb1-8",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdzttb1-5.png")
                          },
                          on: { click: _vm.Loginwdzt1_9 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdzt1_10,
                            expression: "isShowwdzt1_10"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdzt1-10.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdhj1_1,
                            expression: "isShowwdhj1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdzt1-10.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdhjtb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdhjtb1-1.png")
                          },
                          on: { mousemove: _vm.Loginwdhj1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdhj1_2,
                            expression: "isShowwdhj1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdhj1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdhjtb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdhjtb1-2.png")
                          },
                          on: { click: _vm.Loginwdhj1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdhj1_3,
                            expression: "isShowwdhj1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdhj1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdhjtb1-3",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdhjtb1-3.png")
                          },
                          on: { mousemove: _vm.Loginwdhj1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdhj1_4,
                            expression: "isShowwdhj1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdhj1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdhjtb1-4",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdhjtb1-4.png")
                          },
                          on: { click: _vm.Loginwdhj1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdhj1_5,
                            expression: "isShowwdhj1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdhj1-4.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdsj1_1,
                            expression: "isShowwdsj1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdsj1-1.png")
                          },
                          on: {
                            contextmenu: function($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.rightClick_sj($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.isShowwdsj1_1_1
                          ? _c("img", {
                              staticClass: "wdsjtb1-1",
                              attrs: {
                                src: require("../../../static/workoff/excelimg/word/wdsjtb1-1.png")
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isShowwdsj1_1_1
                          ? _c("img", {
                              staticClass: "wdsjtb1-1-1",
                              attrs: {
                                src: require("../../../static/workoff/excelimg/word/wdsjtb1-1-1.png")
                              },
                              on: { mousemove: _vm.Loginwdsj1_1 }
                            })
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdsj1_2,
                            expression: "isShowwdsj1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdsj1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdsjtb1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdsjtb1-2.png")
                          },
                          on: { click: _vm.Loginwdsj1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdsj1_3,
                            expression: "isShowwdsj1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdsj1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdsjtb1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-3",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdsjtb1-3-1.png")
                          },
                          on: { click: _vm.Loginwdsj1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdsj1_4,
                            expression: "isShowwdsj1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdsj1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdsjtb1-4.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-4",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdsjtb1-4-1.png")
                          },
                          on: { mousemove: _vm.Loginwdsj1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdsj1_5,
                            expression: "isShowwdsj1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdsj1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdsjtb1-5.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-5",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdsjtb1-5-1.png")
                          },
                          on: { click: _vm.Loginwdsj1_5 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdsj1_6,
                            expression: "isShowwdsj1_6"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdsj1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdsjtb1-6.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdsjtb1-6",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdsjtb1-6-1.png")
                          },
                          on: { click: _vm.Loginwdsj1_6 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdsj1_7,
                            expression: "isShowwdsj1_7"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdsj1-4.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdjc1_1,
                            expression: "isShowwdjc1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdjc1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-4",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchbtb1-2-1.png")
                          },
                          on: { mousemove: _vm.Loginwdjc1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdjc1_2,
                            expression: "isShowwdjc1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdjc1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jchbtb1-5",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jchbtb1-3.png")
                          },
                          on: { click: _vm.Loginwdjc1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdjc1_3,
                            expression: "isShowwdjc1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdjc1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jztb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jztb1-1.png")
                          },
                          on: { mousemove: _vm.Loginwdjc1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdjc1_4,
                            expression: "isShowwdjc1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdjc1-4.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "jztb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/layout/jztb1-2.png")
                          },
                          on: { click: _vm.Loginwdjc1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdjc1_5,
                            expression: "isShowwdjc1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdjc1-5.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdys1_1,
                            expression: "isShowwdys1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdys1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdystb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdystb1-1.png")
                          },
                          on: { mousemove: _vm.Loginwdys1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdys1_2,
                            expression: "isShowwdys1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdys1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdystb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdystb1-2.png")
                          },
                          on: { click: _vm.Loginwdys1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdys1_3,
                            expression: "isShowwdys1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdys1-3.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdystb1-3",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdystb1-3.png")
                          },
                          on: { mousemove: _vm.Loginwdys1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdys1_4,
                            expression: "isShowwdys1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdys1-4.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdystb1-4",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdystb1-4.png")
                          },
                          on: { click: _vm.Loginwdys1_4 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdys1_5,
                            expression: "isShowwdys1_5"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdys1-5.png")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdtx1_1,
                            expression: "isShowwdtx1_1"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdtx1-1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdtxtb1-1",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdtxtb1-1.png")
                          },
                          on: { mousemove: _vm.Loginwdtx1_1 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdtx1_2,
                            expression: "isShowwdtx1_2"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdtx1-2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "wdtxtb1-2",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdtxtb1-2.png")
                          },
                          on: { click: _vm.Loginwdtx1_2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdtx1_3,
                            expression: "isShowwdtx1_3"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdtx1-3.png")
                          },
                          on: { click: _vm.Loginwdtx1_3 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowwdtx1_4,
                            expression: "isShowwdtx1_4"
                          }
                        ],
                        staticClass: "qnbox nr1_4"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("../../../static/workoff/excelimg/word/wdtx1-4.png")
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _c("h3", [
                    _c("span", { staticClass: "line" }),
                    _vm._v("\n\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _vm.isShowwdzt1_1 ||
                  _vm.isShowwdzt1_2 ||
                  _vm.isShowwdzt1_3 ||
                  _vm.isShowwdzt1_4 ||
                  _vm.isShowwdzt1_5 ||
                  _vm.isShowwdzt1_6 ||
                  _vm.isShowwdzt1_7 ||
                  _vm.isShowwdzt1_8 ||
                  _vm.isShowwdzt1_9 ||
                  _vm.isShowwdzt1_10
                    ? _c("p", [
                        _vm._v("先采用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("快捷键")]
                        ),
                        _vm._v("全选内容，再将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("字体")]
                        ),
                        _vm._v("设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("楷体，字号")]
                        ),
                        _vm._v("设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("小四")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowwdhj1_1 ||
                  _vm.isShowwdhj1_2 ||
                  _vm.isShowwdhj1_3 ||
                  _vm.isShowwdhj1_4 ||
                  _vm.isShowwdhj1_5
                    ? _c("p", [
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("行距")]
                        ),
                        _vm._v("设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("1.5")]
                        ),
                        _vm._v("倍")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowwdsj1_1 ||
                  _vm.isShowwdsj1_2 ||
                  _vm.isShowwdsj1_3 ||
                  _vm.isShowwdsj1_4 ||
                  _vm.isShowwdsj1_5 ||
                  _vm.isShowwdsj1_6 ||
                  _vm.isShowwdsj1_7
                    ? _c("p", [
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("首行缩进2字符")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowwdjc1_1 ||
                  _vm.isShowwdjc1_2 ||
                  _vm.isShowwdjc1_3 ||
                  _vm.isShowwdjc1_4 ||
                  _vm.isShowwdjc1_5
                    ? _c("p", [
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("标题加粗，并居中")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowwdys1_1 ||
                  _vm.isShowwdys1_2 ||
                  _vm.isShowwdys1_3 ||
                  _vm.isShowwdys1_4 ||
                  _vm.isShowwdys1_5
                    ? _c("p", [
                        _vm._v("将"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("2015")]
                        ),
                        _vm._v("设置为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("红色")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isShowwdtx1_1 ||
                  _vm.isShowwdtx1_2 ||
                  _vm.isShowwdtx1_3 ||
                  _vm.isShowwdtx1_4
                    ? _c("p", [
                        _vm._v("用"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("黄色突出显示")]
                        ),
                        _vm._v("最后自然段")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-six" } },
                  [
                    _c("div", { staticClass: "tip" }, [
                      _c("span", { staticClass: "el-icon-success" }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("你已完成办公软件的功能学习，"),
                        _c("br"),
                        _vm._v("接下来请完成《办公软件模拟实操》。")
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          staticStyle: {
                            width: "230px",
                            "border-radius": "5px"
                          },
                          attrs: { href: "/excelstudy" }
                        },
                        [_vm._v("去完成《办公软件模拟实操》")]
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "study-box" },
              [
                _c("h3", [
                  _c("span", { staticClass: "line" }),
                  _vm._v("\n\t\t\t\t\t\t查看学习资料\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 20 } }, [
                      _c("img", {
                        staticClass: "img-box",
                        attrs: {
                          src: require("../../../static/newqianniu/ppt.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "con-box" }, [
                        _c("p", [_vm._v("办公软件的功能学习.ppt")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm.isOpenPpt6
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewPpt6(false)
                                    }
                                  }
                                },
                                [_vm._v("点击收起")]
                              )
                            : _c(
                                "a",
                                {
                                  staticClass: "btn-open",
                                  on: { click: _vm.viewPpt6 }
                                },
                                [_vm._v("点击展开")]
                              )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 4 } },
                      [
                        _vm.isShowBtn[_vm.tabCurrent]
                          ? _c(
                              "el-button",
                              {
                                staticClass: "pull-right startbtn",
                                attrs: { type: "primary" },
                                on: { click: _vm.startStudy }
                              },
                              [_vm._v("开始练习")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "pdf_viewer6" } })
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7dc4f9b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dc4f9b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/excel/newexcel.vue
// module id = 1664
// module chunks = 0